(function () {
    "use strict";

    var root = document.documentElement;
    var header = document.querySelector("[data-site-header]");
    var menuButton = document.querySelector("[data-menu-toggle]");
    var mobileMenu = document.querySelector("[data-mobile-menu]");
    var themeButton = document.querySelector("[data-theme-toggle]");
    var copyButton = document.querySelector("[data-copy-link]");
    var mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    var motionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");

    function configuredTheme() {
        return root.dataset.colorScheme || "Dark";
    }

    function resolvedTheme(mode) {
        if (mode === "Auto") {
            return mediaQuery.matches ? "Dark" : "Light";
        }
        return mode;
    }

    function applyTheme(mode, persist) {
        root.dataset.theme = resolvedTheme(mode).toLowerCase();
        if (persist) {
            localStorage.setItem("bahnnews-color-scheme", mode);
        }
        if (themeButton) {
            themeButton.setAttribute(
                "aria-label",
                mode === "Dark" ? themeButton.dataset.lightLabel : themeButton.dataset.darkLabel
            );
        }
    }

    function closeMenu() {
        if (!menuButton || !mobileMenu) {
            return;
        }
        menuButton.setAttribute("aria-expanded", "false");
        mobileMenu.hidden = true;
        document.body.classList.remove("menu-open");
    }

    if (header) {
        var updateHeader = function () {
            header.classList.toggle("is-scrolled", window.scrollY > 12);
        };
        updateHeader();
        window.addEventListener("scroll", updateHeader, {passive: true});
    }

    if (menuButton && mobileMenu) {
        menuButton.addEventListener("click", function () {
            var opening = menuButton.getAttribute("aria-expanded") !== "true";
            menuButton.setAttribute("aria-expanded", String(opening));
            mobileMenu.hidden = !opening;
            document.body.classList.toggle("menu-open", opening);
        });
        mobileMenu.addEventListener("click", function (event) {
            if (event.target.closest("a")) {
                closeMenu();
            }
        });
        window.addEventListener("keydown", function (event) {
            if (event.key === "Escape") {
                closeMenu();
            }
        });
    }

    if (themeButton) {
        var savedTheme = localStorage.getItem("bahnnews-color-scheme") || configuredTheme();
        applyTheme(savedTheme, false);
        themeButton.addEventListener("click", function () {
            var nextTheme = root.dataset.theme === "dark" ? "Light" : "Dark";
            applyTheme(nextTheme, true);
        });
        mediaQuery.addEventListener("change", function () {
            var selected = localStorage.getItem("bahnnews-color-scheme") || configuredTheme();
            if (selected === "Auto") {
                applyTheme("Auto", false);
            }
        });
    }

    if (copyButton) {
        copyButton.addEventListener("click", async function () {
            var originalLabel = copyButton.textContent;
            try {
                await navigator.clipboard.writeText(window.location.href);
                copyButton.textContent = document.documentElement.lang.startsWith("de") ? "Link kopiert" : "Link copied";
                window.setTimeout(function () {
                    copyButton.textContent = originalLabel;
                }, 1800);
            } catch (error) {
                window.prompt("Copy this link:", window.location.href);
            }
        });
    }

    var cookieConsentRoot = document.querySelector("[data-cookie-consent]");
    if (cookieConsentRoot) {
        var consentStorageKey = "bahnnews-cookie-consent-v1";
        var consentVersion = 1;
        var consentMaxAge = 180 * 24 * 60 * 60 * 1000;
        var cookieBanner = cookieConsentRoot.querySelector("[data-cookie-banner]");
        var cookieModal = cookieConsentRoot.querySelector("[data-cookie-modal]");
        var cookieDialog = cookieConsentRoot.querySelector("[data-cookie-dialog]");
        var statisticsInput = cookieConsentRoot.querySelector("[data-cookie-statistics]");
        var externalInput = cookieConsentRoot.querySelector("[data-cookie-external]");
        var settingsOpener = null;
        var currentConsent = readConsent();

        function normalizedConsent(settings) {
            return {
                version: consentVersion,
                necessary: true,
                statistics: Boolean(settings && settings.statistics),
                external: Boolean(settings && settings.external),
                timestamp: new Date().toISOString()
            };
        }

        function readConsent() {
            try {
                var stored = JSON.parse(localStorage.getItem(consentStorageKey));
                var storedAt = Date.parse(stored && stored.timestamp);
                if (
                    !stored ||
                    stored.version !== consentVersion ||
                    !Number.isFinite(storedAt) ||
                    Date.now() - storedAt > consentMaxAge
                ) {
                    return null;
                }
                return normalizedConsent(stored);
            } catch (error) {
                return null;
            }
        }

        function writeConsent(consent) {
            try {
                localStorage.setItem(consentStorageKey, JSON.stringify(consent));
            } catch (error) {
                // The preference remains active for this page when storage is unavailable.
            }
        }

        function activateScripts(category) {
            var selector = "script[type=\"text/plain\"][data-cookie-category=\"" + category + "\"]:not([data-cookie-activated])";
            document.querySelectorAll(selector).forEach(function (blockedScript) {
                var activeScript = document.createElement("script");
                Array.from(blockedScript.attributes).forEach(function (attribute) {
                    if (!["type", "data-cookie-category", "data-cookie-activated"].includes(attribute.name)) {
                        activeScript.setAttribute(attribute.name, attribute.value);
                    }
                });
                if (blockedScript.src && !blockedScript.hasAttribute("async")) {
                    activeScript.async = false;
                }
                activeScript.text = blockedScript.textContent;
                blockedScript.dataset.cookieActivated = "true";
                blockedScript.parentNode.insertBefore(activeScript, blockedScript.nextSibling);
            });
        }

        function activateExternalMedia() {
            document.querySelectorAll("[data-cookie-category=\"external-media\"][data-cookie-src]").forEach(function (media) {
                if (!media.getAttribute("src")) {
                    media.setAttribute("src", media.dataset.cookieSrc);
                }
            });
        }

        function updateGoogleConsent(consent) {
            if (typeof window.gtag !== "function") {
                return;
            }
            window.gtag("consent", "update", {
                analytics_storage: consent.statistics ? "granted" : "denied",
                ad_storage: "denied",
                ad_user_data: "denied",
                ad_personalization: "denied"
            });
        }

        function applyConsent(consent) {
            if (consent.statistics) {
                activateScripts("statistics");
            }
            if (consent.external) {
                activateScripts("external-media");
                activateExternalMedia();
            }
            updateGoogleConsent(consent);
            window.dispatchEvent(new CustomEvent("bahnnews:consent", {detail: consent}));
        }

        function closeSettings() {
            cookieModal.hidden = true;
            document.body.classList.remove("consent-open");
            if (settingsOpener) {
                settingsOpener.focus();
                settingsOpener = null;
            }
        }

        function openSettings(opener) {
            settingsOpener = opener || document.activeElement;
            statisticsInput.checked = Boolean(currentConsent && currentConsent.statistics);
            externalInput.checked = Boolean(currentConsent && currentConsent.external);
            cookieModal.hidden = false;
            document.body.classList.add("consent-open");
            cookieDialog.focus();
        }

        function saveConsent(settings) {
            var previousConsent = currentConsent;
            var nextConsent = normalizedConsent(settings);
            var revokedConsent = previousConsent && (
                (previousConsent.statistics && !nextConsent.statistics) ||
                (previousConsent.external && !nextConsent.external)
            );

            currentConsent = nextConsent;
            writeConsent(nextConsent);
            cookieBanner.hidden = true;
            closeSettings();
            applyConsent(nextConsent);

            if (revokedConsent) {
                window.location.reload();
            }
        }

        cookieConsentRoot.querySelectorAll("[data-cookie-accept-all]").forEach(function (button) {
            button.addEventListener("click", function () {
                saveConsent({statistics: true, external: true});
            });
        });

        cookieConsentRoot.querySelectorAll("[data-cookie-necessary]").forEach(function (button) {
            button.addEventListener("click", function () {
                saveConsent({statistics: false, external: false});
            });
        });

        document.querySelectorAll("[data-cookie-settings-open]").forEach(function (button) {
            button.addEventListener("click", function () {
                openSettings(button);
            });
        });

        cookieConsentRoot.querySelector("[data-cookie-save]").addEventListener("click", function () {
            saveConsent({
                statistics: statisticsInput.checked,
                external: externalInput.checked
            });
        });

        cookieConsentRoot.querySelectorAll("[data-cookie-close]").forEach(function (button) {
            button.addEventListener("click", closeSettings);
        });

        cookieModal.addEventListener("keydown", function (event) {
            if (event.key === "Escape") {
                closeSettings();
                return;
            }
            if (event.key !== "Tab") {
                return;
            }

            var focusable = Array.from(cookieDialog.querySelectorAll("button:not([disabled]), input:not([disabled]), a[href]"));
            var firstFocusable = focusable[0];
            var lastFocusable = focusable[focusable.length - 1];
            if (event.shiftKey && document.activeElement === firstFocusable) {
                event.preventDefault();
                lastFocusable.focus();
            } else if (!event.shiftKey && document.activeElement === lastFocusable) {
                event.preventDefault();
                firstFocusable.focus();
            }
        });

        window.BahnnewsConsent = {
            get: function () {
                return currentConsent ? Object.assign({}, currentConsent) : null;
            },
            has: function (category) {
                return Boolean(currentConsent && currentConsent[category]);
            },
            open: function () {
                openSettings();
            }
        };

        if (currentConsent) {
            cookieBanner.hidden = true;
            applyConsent(currentConsent);
        } else {
            cookieBanner.hidden = false;
        }
    }

    document.querySelectorAll("[data-departure-board]").forEach(function (boardRoot) {
        var boardList = boardRoot.querySelector("[data-board-list]");
        var boardStatus = boardRoot.querySelector("[data-board-status]");
        var boardUpdated = boardRoot.querySelector("[data-board-updated]");
        var boardSourceLink = boardRoot.querySelector("[data-board-source-link]");
        var boardSourceLabel = boardRoot.querySelector("[data-board-source-label]");
        var boardSourceMode = boardRoot.querySelector("[data-board-source-mode]");
        var refreshNotice = boardRoot.querySelector("[data-board-refresh-notice]");
        var refreshMessage = boardRoot.querySelector("[data-board-refresh-message]");
        var refreshButton = boardRoot.querySelector("[data-board-refresh-button]");
        var boardPanel = boardRoot.querySelector("[data-board-panel]");
        var boardSource = boardRoot.querySelector("[data-board-source]");
        var boardTabs = Array.from(boardRoot.querySelectorAll("[data-board-filter]"));
        var stateFilter = boardRoot.querySelector("[data-board-state-filter]");
        var stateSelect = boardRoot.querySelector("[data-board-state-select]");
        var boardSearch = boardRoot.querySelector("[data-board-search]");
        var boardSearchCount = boardRoot.querySelector("[data-board-search-count]");
        var boardLimit = Number(boardRoot.dataset.boardLimit) || 5;
        var feedUrl = boardRoot.dataset.feedUrl;
        var proxyUrl = boardRoot.dataset.feedProxyUrl;
        var isHomepageBoard = boardRoot.dataset.boardContext === "home";
        var activeFilter = "current";
        var activeState = "";
        var activeQuery = "";
        var searchTimer;
        var messages = document.documentElement.lang.startsWith("de") ? {
            current: "Störung",
            resolved: "Behoben",
            cancellation: "Ausfall",
            construction: "Baustelle",
            replacement: "Ersatzverkehr",
            information: "Information",
            noResults: {
                current: "Derzeit sind keine akuten Störungen gemeldet.",
                resolved: "Derzeit sind keine behobenen Störungen von ÖBB HAFAS enthalten.",
                cancellation: "Derzeit sind keine Ausfälle gemeldet.",
                construction: "Derzeit sind keine Baustellen gemeldet.",
                replacement: "Derzeit ist kein Ersatzverkehr gemeldet.",
                information: "Derzeit sind keine allgemeinen Informationen gemeldet."
            },
            noConstructionState: "Für dieses Bundesland sind derzeit keine Baustellen gemeldet.",
            noSearchResults: "Keine Meldung passt zu dieser Suche.",
            searchResults: "Treffer",
            allStates: "Alle Bundesländer",
            loadError: "Die Verkehrsmeldungen können momentan nicht geladen werden.",
            setupError: "Der Verkehrsmeldungs-Proxy ist noch nicht eingerichtet.",
            checked: "Zuletzt von HAFAS abgerufen",
            rssChecked: "Ersatzdaten abgerufen",
            sourceError: "Quelle derzeit nicht erreichbar",
            sourceHafas: "ÖBB HAFAS",
            sourceRss: "ÖBB Verkehrsmeldungen",
            fallbackNote: "Derzeit werden eingeschränkte Ersatzdaten angezeigt.",
            lastGoodNote: "Letzter erfolgreicher Datenstand.",
            newData: "Neue Verkehrsdaten sind verfügbar.",
            nationwide: "Österreich",
            train: "Zug",
            departureFrom: "ab",
            valid: "Meldungszeitraum",
            affectedLines: "Betroffene Linien",
            associatedLines: "Linien mit dieser Meldung",
            furtherInformation: "Fahrplan / weitere Informationen",
            moreTrains: "weitere zugeordnete Fahrten",
            moreLines: "weitere Linien",
            details: "Meldungsdetails ein- oder ausklappen",
            open: "Meldung in der ÖBB Fahrplanauskunft öffnen"
        } : {
            current: "Disruption",
            resolved: "Resolved",
            cancellation: "Cancellation",
            construction: "Construction work",
            replacement: "Replacement service",
            information: "Information",
            noResults: {
                current: "There are currently no acute disruptions.",
                resolved: "There are currently no resolved disruptions in ÖBB HAFAS.",
                cancellation: "There are currently no cancellations reported.",
                construction: "There is currently no construction work reported.",
                replacement: "There are currently no replacement services reported.",
                information: "There is currently no general information reported."
            },
            noConstructionState: "There is currently no construction work reported for this state.",
            noSearchResults: "No traffic information matches this search.",
            searchResults: "results",
            allStates: "All federal states",
            loadError: "Traffic information cannot be loaded at the moment.",
            setupError: "The traffic information proxy has not been configured yet.",
            checked: "Last fetched from HAFAS",
            rssChecked: "Replacement data fetched",
            sourceError: "Source currently unavailable",
            sourceHafas: "ÖBB HAFAS",
            sourceRss: "ÖBB traffic information",
            fallbackNote: "Limited replacement data is currently being displayed.",
            lastGoodNote: "Last successful data update.",
            newData: "New traffic information is available.",
            nationwide: "Austria",
            train: "Train",
            departureFrom: "from",
            valid: "Notice period",
            affectedLines: "Affected lines",
            associatedLines: "Lines carrying this notice",
            furtherInformation: "Timetable / further information",
            moreTrains: "more associated services",
            moreLines: "more lines",
            details: "Expand or collapse notice details",
            open: "Open notice in the ÖBB journey planner"
        };
        var dateFormatter = new Intl.DateTimeFormat(document.documentElement.lang || "de", {
            day: "2-digit",
            month: "2-digit",
            hour: "2-digit",
            minute: "2-digit"
        });
        var items = [];
        var trainLookupRunning = false;
        var trainLookupGeneration = 0;
        var journeyDateFormatter = new Intl.DateTimeFormat(document.documentElement.lang || "de", {
            timeZone: "Europe/Vienna", day: "2-digit", month: "2-digit", year: "numeric",
            hour: "2-digit", minute: "2-digit"
        });

        function journeyDate(value) {
            var date = value ? new Date(value) : null;
            return date && !Number.isNaN(date.getTime()) ? journeyDateFormatter.format(date) : "";
        }

        function trainText(train) {
            var name = normalizedText(train.name);
            var number = normalizedText(train.number);
            var label = name;
            if (number && !name.split(/\s+/).includes(number)) {
                label += " · " + messages.train + " " + number;
            }
            var departure = journeyDate(train.plannedDeparture);
            var station = normalizedText(train.station && train.station.name);
            var direction = normalizedText(train.direction);
            return label + (departure ? " · " + departure : "") +
                (station ? " " + messages.departureFrom + " " + station : "") +
                (direction ? " → " + direction : "");
        }

        function renderTrainInfo(container, item, limit) {
            container.replaceChildren();
            if (item.trainSpecific === false) {
                var names = Array.from(new Set((item.trains || []).map(function (train) {
                    return normalizedText(train.lineName || train.name);
                }).filter(Boolean)));
                if (limit === Infinity && names.length <= 3) return;
                if (names.length) {
                    var lines = document.createElement("span");
                    lines.textContent = messages.associatedLines + ": " + names.slice(0, limit).join(" · ") +
                        (names.length > limit ? " · + " + (names.length - limit) + " " + messages.moreLines : "");
                    container.appendChild(lines);
                }
                return;
            }
            if (limit === Infinity && (item.trains || []).length <= 3) return;
            (item.trains || []).slice(0, limit).forEach(function (train) {
                var line = document.createElement("span");
                line.textContent = trainText(train);
                container.appendChild(line);
            });
            if (item.trains && item.trains.length > limit) {
                var more = document.createElement("span");
                more.textContent = "+ " + (item.trains.length - limit) + " " + messages.moreTrains;
                container.appendChild(more);
            }
        }

        function loadVisibleTrains() {
            if (!proxyUrl || trainLookupRunning) return;
            var visibleIds = Array.from(boardList.querySelectorAll("[data-remark-id]"))
                .map(function (row) { return row.dataset.remarkId; });
            var batch = items.filter(function (item) {
                return item.id && visibleIds.includes(item.id) && !item.trainsLoaded;
            }).slice(0, 12);
            if (!batch.length) return;
            trainLookupRunning = true;
            var generation = trainLookupGeneration;
            var endpoint = proxyEndpoint("/remarks/trains");
            endpoint.searchParams.set("ids", batch.map(function (item) { return item.id; }).join(","));
            var controller = new AbortController();
            var timeout = window.setTimeout(function () { controller.abort(); }, 20000);
            fetch(endpoint.href, {headers: {Accept: "application/json"}, signal: controller.signal})
                .then(function (response) {
                    if (!response.ok) throw new Error("Train lookup unavailable");
                    return response.json();
                })
                .then(function (payload) {
                    if (generation !== trainLookupGeneration) return;
                    batch.forEach(function (item) {
                        var trains = payload.assignments && payload.assignments[item.id];
                        item.trains = Array.isArray(trains) ? trains.filter(function (train) {
                            return train && train.name && train.number;
                        }) : [];
                    });
                    // Update rows in place so an open notice stays open.
                    boardList.querySelectorAll("[data-remark-id]").forEach(function (row) {
                        var item = batch.find(function (entry) { return entry.id === row.dataset.remarkId; });
                        if (!item) return;
                        renderTrainInfo(row.querySelector("[data-train-summary]"), item, 3);
                        var detail = row.querySelector("[data-train-detail]");
                        if (detail) renderTrainInfo(detail, item, Infinity);
                    });
                })
                .catch(function () {
                    // Optional information stays absent on an unsuccessful lookup.
                })
                .finally(function () {
                    window.clearTimeout(timeout);
                    if (generation === trainLookupGeneration) {
                        batch.forEach(function (item) { item.trainsLoaded = true; });
                    }
                    trainLookupRunning = false;
                    if (activeQuery) renderBoard();
                    else loadVisibleTrains();
                });
        }

        function normalizedText(value) {
            return String(value || "").replace(/\s+/g, " ").trim();
        }

        function textContent(node, selector) {
            var element = node.querySelector(selector);
            return normalizedText(element && element.textContent);
        }

        function plainDescription(value) {
            var documentFragment = new DOMParser().parseFromString(value || "", "text/html");
            return normalizedText(documentFragment.body.textContent);
        }

        function safeExternalUrl(value) {
            try {
                var url = new URL(value);
                return url.protocol === "https:" ? url.href : "";
            } catch (error) {
                return "";
            }
        }

        function parseFeed(xml) {
            var feedDocument = new DOMParser().parseFromString(xml, "application/xml");
            if (feedDocument.querySelector("parsererror")) {
                throw new Error("Invalid RSS response");
            }

            return Array.from(feedDocument.querySelectorAll("channel > item")).map(function (item) {
                var categories = Array.from(item.querySelectorAll("category"));
                var rawType = categories.filter(function (category) {
                    return category.getAttribute("domain") === "type";
                }).map(function (category) {
                    return normalizedText(category.textContent);
                }).join(" ").toLocaleLowerCase("de");
                var title = textContent(item, "title");
                var description = plainDescription(textContent(item, "description"));
                var searchableText = (title + " " + description).toLocaleLowerCase("de");
                var isResolved = rawType.includes("behob") ||
                    /\b(aufhebung|aufgehoben|behoben)\b/.test(searchableText);
                var filters = [];

                if ((rawType.includes("stör") || rawType.includes("him5")) && !isResolved) {
                    filters.push("current");
                }
                if (isResolved || rawType.includes("him6")) {
                    filters.push("resolved");
                }
                if (/\b((zug|teil)?ausf(all|älle|aelle)|entfällt|entfallen)\b|nicht fahren/.test(searchableText)) {
                    filters.push("cancellation");
                }
                if (rawType.includes("bau") || rawType.includes("him1")) {
                    filters.push("construction");
                }
                if (/\b(bus|schienen)?ersatzverkehr\b|\bersatzbeförderung\b/.test(searchableText)) {
                    filters.push("replacement");
                }
                if (rawType.includes("info") || rawType.includes("him4")) {
                    filters.push("information");
                }
                if (!filters.length) {
                    filters.push("information");
                }

                var status = isResolved || rawType.includes("him6") ? "resolved" :
                    rawType.includes("bau") || rawType.includes("him1") ? "construction" :
                        rawType.includes("info") || rawType.includes("him4") ? "information" :
                            rawType.includes("ausfall") || rawType.includes("him2") ? "cancellation" : "current";
                var publishedAt = new Date(textContent(item, "pubDate"));

                return {
                    filters: filters,
                    status: status,
                    title: title,
                    description: description,
                    states: categories.filter(function (entry) {
                        return entry.getAttribute("domain") === "state";
                    }).map(function (entry) {
                        return normalizedText(entry.textContent);
                    }).filter(Boolean),
                    regions: categories.filter(function (entry) {
                        return entry.getAttribute("domain") === "state";
                    }).map(function (entry) {
                        return normalizedText(entry.textContent);
                    }).filter(Boolean),
                    publishedAt: Number.isNaN(publishedAt.getTime()) ? null : publishedAt,
                    url: safeExternalUrl(textContent(item, "link"))
                };
            }).filter(function (item) {
                return item.filters.length && item.title;
            }).sort(function (first, second) {
                return (second.publishedAt ? second.publishedAt.getTime() : 0) -
                    (first.publishedAt ? first.publishedAt.getTime() : 0);
            });
        }

        function parseRemarks(payload) {
            if (!payload || !Array.isArray(payload.remarks)) {
                throw new Error("Invalid HAFAS response");
            }

            var remarks = payload.remarks.map(function (remark) {
                var iconType = normalizedText(remark.iconType).toUpperCase();
                var categories = Array.isArray(remark.categories) ? remark.categories.map(Number) : [];
                var title = normalizedText(remark.summary) || plainDescription(remark.text).slice(0, 180);
                var description = plainDescription(remark.text);
                var searchableText = (title + " " + description).toLocaleLowerCase("de");
                var filters = [];

                function addFilter(filter) {
                    if (!filters.includes(filter)) {
                        filters.push(filter);
                    }
                }

                if (iconType === "HIM5" || categories.includes(5)) {
                    addFilter("current");
                }
                if (iconType === "HIM6") {
                    addFilter("resolved");
                }
                if (iconType === "HIM2" || /\b((zug|teil)?ausf(all|älle|aelle)|entfällt|entfaellt|entfallen)\b|nicht fahren/.test(searchableText)) {
                    addFilter("cancellation");
                }
                if (iconType === "HIM1") {
                    addFilter("construction");
                }
                if (/\b(bus|schienen)?ersatzverkehr\b|\bersatzbeförderung\b|\bersatzbefoerderung\b/.test(searchableText)) {
                    addFilter("replacement");
                }
                if (iconType === "HIM4") {
                    addFilter("information");
                }

                var status = iconType === "HIM6" ? "resolved" :
                    iconType === "HIM1" ? "construction" :
                        iconType === "HIM4" ? "information" :
                            iconType === "HIM2" ? "cancellation" : "current";
                var rawDate = remark.modified || remark.validFrom;
                var publishedAt = rawDate ? new Date(rawDate) : null;

                return {
                    filters: filters,
                    status: status,
                    title: title,
                    description: description !== title ? description : "",
                    id: normalizedText(remark.id),
                    states: [],
                    regions: Array.isArray(remark.regions) ? remark.regions.map(normalizedText).filter(Boolean) : [],
                    affectedLines: Array.isArray(remark.affectedLines) ? remark.affectedLines.map(normalizedText).filter(Boolean) : [],
                    affectedSections: Array.isArray(remark.affectedSections) ? remark.affectedSections : [],
                    validFrom: remark.validFrom,
                    validUntil: remark.validUntil,
                    trains: Array.isArray(remark.trains) ? remark.trains : [],
                    trainSpecific: remark.trainSpecific === true,
                    trainsLoaded: Array.isArray(remark.trains),
                    links: Array.isArray(remark.links) ? remark.links.map(safeExternalUrl).filter(Boolean) : [],
                    publishedAt: publishedAt && !Number.isNaN(publishedAt.getTime()) ? publishedAt : null,
                    url: ""
                };
            }).filter(function (item) {
                return item.filters.length && item.title;
            }).sort(function (first, second) {
                return (second.publishedAt ? second.publishedAt.getTime() : 0) -
                    (first.publishedAt ? first.publishedAt.getTime() : 0);
            });
            var updatedAt = payload.updatedAt ? new Date(payload.updatedAt) : new Date();
            var fetchedAt = payload.fetchedAt ? new Date(payload.fetchedAt) :
                (payload.updatedAt ? new Date(payload.updatedAt) : null);

            return {
                items: remarks,
                updatedAt: Number.isNaN(updatedAt.getTime()) ? null : updatedAt,
                fetchedAt: fetchedAt && !Number.isNaN(fetchedAt.getTime()) ? fetchedAt : null,
                checkedAt: new Date(),
                source: "hafas"
            };
        }

        function parseTrafficResponse(body, contentType, dataState) {
            if ((contentType || "").includes("application/json") || /^\s*\{/.test(body)) {
                var parsed = parseRemarks(JSON.parse(body));
                parsed.dataState = dataState || "current";
                return parsed;
            }
            return {
                items: parseFeed(body),
                updatedAt: null,
                checkedAt: new Date(),
                fetchedAt: null,
                source: "rss",
                dataState: "fallback"
            };
        }

        function createRow(item) {
            var row = document.createElement("li");
            var hasDetails = Boolean(item.description || item.url || item.id);
            var entry = document.createElement(hasDetails ? "details" : "div");
            var summary = document.createElement(hasDetails ? "summary" : "div");
            var time = document.createElement("time");
            var information = document.createElement("span");
            var title = document.createElement("strong");
            var region = document.createElement("span");
            var badge = document.createElement("span");
            var actions = document.createElement("span");

            row.className = "departure-board-row departure-board-row-" + item.status;
            if (item.id) row.dataset.remarkId = item.id;
            entry.className = "departure-board-entry";
            summary.className = "departure-board-row-link";

            time.className = "departure-board-time";
            if (item.publishedAt) {
                time.dateTime = item.publishedAt.toISOString();
                time.textContent = dateFormatter.format(item.publishedAt);
            } else {
                time.textContent = "–";
            }

            information.className = "departure-board-information";
            title.textContent = item.title;
            information.appendChild(title);
            if (item.affectedLines && item.affectedLines.length) {
                var lines = document.createElement("span");
                lines.className = "departure-board-context";
                lines.textContent = messages.affectedLines + ": " + item.affectedLines.join(" · ");
                information.appendChild(lines);
            }
            var trainSummary = document.createElement("span");
            trainSummary.className = "departure-board-trains";
            trainSummary.dataset.trainSummary = "";
            renderTrainInfo(trainSummary, item, 3);
            information.appendChild(trainSummary);
            var validFrom = journeyDate(item.validFrom);
            var validUntil = journeyDate(item.validUntil);
            if (validFrom || validUntil) {
                var validity = document.createElement("span");
                validity.className = "departure-board-context";
                validity.textContent = messages.valid + ": " + [validFrom, validUntil].filter(Boolean).join(" – ");
                information.appendChild(validity);
            }

            region.className = "departure-board-region";
            region.textContent = item.regions.length ? item.regions.join(", ") : messages.nationwide;
            if (item.affectedSections && item.affectedSections.length) {
                var routes = item.affectedSections.map(function (section) {
                    return [normalizedText(section.from && section.from.name), normalizedText(section.to && section.to.name)]
                        .filter(function (name, index, names) { return name && names.indexOf(name) === index; }).join(" → ");
                }).filter(Boolean);
                if (routes.length) region.textContent = Array.from(new Set(routes)).join(" · ");
            }

            badge.className = "departure-board-badge";
            badge.textContent = messages[item.status];
            actions.className = "departure-board-row-actions";
            actions.appendChild(badge);

            if (hasDetails) {
                var expand = document.createElement("span");
                var expandLabel = document.createElement("span");
                var expandIcon = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                var expandPath = document.createElementNS("http://www.w3.org/2000/svg", "path");

                expand.className = "departure-board-expand";
                expandLabel.className = "visually-hidden";
                expandLabel.textContent = messages.details;
                expandIcon.classList.add("departure-board-expand-icon");
                expandIcon.setAttribute("viewBox", "0 0 24 24");
                expandIcon.setAttribute("fill", "none");
                expandIcon.setAttribute("stroke", "currentColor");
                expandIcon.setAttribute("stroke-width", "2");
                expandIcon.setAttribute("stroke-linecap", "round");
                expandIcon.setAttribute("stroke-linejoin", "round");
                expandIcon.setAttribute("aria-hidden", "true");
                expandPath.setAttribute("d", "m6 9 6 6 6-6");
                expandIcon.appendChild(expandPath);
                expand.append(expandLabel, expandIcon);
                actions.appendChild(expand);
            }

            summary.append(time, information, region, actions);
            entry.appendChild(summary);

            if (hasDetails) {
                var detail = document.createElement("div");
                var detailInner = document.createElement("div");
                detail.className = "departure-board-detail";
                detailInner.className = "departure-board-detail-inner";
                var trainDetail = document.createElement("div");
                trainDetail.className = "departure-board-trains departure-board-trains-detail";
                trainDetail.dataset.trainDetail = "";
                renderTrainInfo(trainDetail, item, Infinity);
                detailInner.appendChild(trainDetail);
                if (item.description) {
                    var description = document.createElement("p");
                    description.className = "departure-board-description";
                    description.textContent = item.description;
                    detailInner.appendChild(description);
                }
                if (item.url) {
                    var sourceLink = document.createElement("a");
                    sourceLink.className = "departure-board-detail-link";
                    sourceLink.href = item.url;
                    sourceLink.target = "_blank";
                    sourceLink.rel = "external nofollow noopener";
                    sourceLink.textContent = messages.open + " →";
                    detailInner.appendChild(sourceLink);
                }
                (item.links || []).forEach(function (url, index) {
                    var link = document.createElement("a");
                    link.className = "departure-board-detail-link";
                    link.href = url;
                    link.target = "_blank";
                    link.rel = "external nofollow noopener";
                    link.textContent = messages.furtherInformation + (item.links.length > 1 ? " " + (index + 1) : "") + " →";
                    detailInner.appendChild(link);
                });
                detail.appendChild(detailInner);
                entry.appendChild(detail);
                enableDetailsAnimation(entry, detail);
            }

            row.appendChild(entry);
            return row;
        }

        function enableDetailsAnimation(entry, detail) {
            var summary = entry.querySelector("summary");
            var animation;

            summary.addEventListener("click", function (event) {
                event.preventDefault();
                if (animation) {
                    return;
                }
                if (motionQuery.matches) {
                    entry.open = !entry.open;
                    return;
                }

                var opening = !entry.open;
                if (opening) {
                    entry.open = true;
                }
                var startHeight = opening ? 0 : detail.offsetHeight;
                var endHeight = opening ? detail.scrollHeight : 0;

                animation = detail.animate([
                    {height: startHeight + "px", opacity: opening ? 0 : 1, transform: opening ? "translateY(-0.35rem)" : "translateY(0)"},
                    {height: endHeight + "px", opacity: opening ? 1 : 0, transform: opening ? "translateY(0)" : "translateY(-0.35rem)"}
                ], {
                    duration: 280,
                    easing: "cubic-bezier(0.22, 1, 0.36, 1)"
                });
                animation.addEventListener("finish", function () {
                    if (!opening) {
                        entry.open = false;
                    }
                    animation = null;
                }, {once: true});
            });
        }

        function renderBoard() {
            var filteredItems = items.filter(function (item) {
                return item.filters.includes(activeFilter) && (
                    activeFilter !== "construction" ||
                    !activeState ||
                    item.states.includes(activeState)
                ) && (!activeQuery || [item.title, item.description]
                    .concat(item.regions, item.states, item.affectedLines || [], (item.trains || []).map(trainText))
                    .join(" ")
                    .toLocaleLowerCase(document.documentElement.lang || "de")
                    .includes(activeQuery));
            });

            boardList.replaceChildren();
            if (stateFilter && stateSelect) {
                stateFilter.hidden = activeFilter !== "construction" || stateSelect.options.length < 2;
            }
            boardTabs.forEach(function (tab) {
                var selected = tab.dataset.boardFilter === activeFilter;
                tab.classList.toggle("is-active", selected);
                tab.setAttribute("aria-selected", String(selected));
                tab.tabIndex = selected ? 0 : -1;
            });
            boardList.setAttribute("aria-labelledby", boardTabs.find(function (tab) {
                return tab.dataset.boardFilter === activeFilter;
            }).id);
            if (boardSearchCount) {
                boardSearchCount.hidden = !activeQuery;
                boardSearchCount.textContent = filteredItems.length + " " + messages.searchResults;
            }

            if (!filteredItems.length) {
                boardStatus.hidden = false;
                boardStatus.textContent = activeQuery ? messages.noSearchResults : activeFilter === "construction" && activeState ?
                    messages.noConstructionState : messages.noResults[activeFilter];
                boardRoot.classList.add("is-empty");
                return;
            }

            boardStatus.hidden = true;
            boardRoot.classList.remove("is-empty");
            filteredItems.slice(0, boardLimit).forEach(function (item) {
                boardList.appendChild(createRow(item));
            });
            loadVisibleTrains();
        }

        function updateStateOptions() {
            if (!stateSelect) {
                return;
            }
            var stateCounts = new Map();
            var constructionItems = items.filter(function (item) {
                return item.filters.includes("construction");
            });

            constructionItems.forEach(function (item) {
                new Set(item.states).forEach(function (state) {
                    stateCounts.set(state, (stateCounts.get(state) || 0) + 1);
                });
            });

            stateSelect.replaceChildren();
            var allStatesOption = document.createElement("option");
            allStatesOption.value = "";
            allStatesOption.textContent = messages.allStates + " (" + constructionItems.length + ")";
            stateSelect.appendChild(allStatesOption);

            Array.from(stateCounts.keys()).sort(function (first, second) {
                return first.localeCompare(second, document.documentElement.lang || "de");
            }).forEach(function (state) {
                var option = document.createElement("option");
                option.value = state;
                option.textContent = state + " (" + stateCounts.get(state) + ")";
                stateSelect.appendChild(option);
            });

            if (!stateCounts.has(activeState)) {
                activeState = "";
            }
            stateSelect.value = activeState;
        }

        function updateCounts() {
            boardRoot.querySelectorAll("[data-board-count]").forEach(function (counter) {
                counter.textContent = String(items.filter(function (item) {
                    return item.filters.includes(counter.dataset.boardCount);
                }).length);
            });
        }

        function updateHomepageVisibility() {
            if (!isHomepageBoard) {
                return true;
            }
            var hasCurrentDisruptions = items.some(function (item) {
                return item.filters.includes("current");
            });

            boardPanel.hidden = false;
            boardSource.hidden = false;
            boardRoot.classList.toggle("is-home-empty", !hasCurrentDisruptions);
            return true;
        }

        function updateCheckedAt(checkedAt, label) {
            var time = document.createElement("time");

            time.dateTime = checkedAt.toISOString();
            time.textContent = dateFormatter.format(checkedAt);
            boardUpdated.replaceChildren(
                document.createTextNode(label + ": "),
                time
            );
        }

        function updateSource(parsed) {
            if (!boardSourceLink || !boardSourceLabel || !boardSourceMode) {
                return;
            }
            var isFallback = parsed.source === "rss";
            boardSourceLabel.textContent = isFallback ? messages.sourceRss : messages.sourceHafas;
            boardSourceLink.href = isFallback ?
                "https://www.unsereoebb.at/de/verkehrsmeldungen" :
                "https://fahrplan.oebb.at/webapp/";
            boardSourceMode.hidden = !isFallback && parsed.dataState !== "last-good";
            boardSourceMode.textContent = isFallback ? messages.fallbackNote : messages.lastGoodNote;
            boardSourceMode.classList.toggle("is-fallback", isFallback);
        }

        function proxyEndpoint(pathname) {
            var endpoint = new URL(proxyUrl, window.location.origin);

            endpoint.pathname = endpoint.pathname
                .replace(/\/(remarks|feed)\/?$/, "")
                .replace(/\/$/, "") + pathname;
            endpoint.search = "";
            endpoint.hash = "";
            return endpoint;
        }

        function requestUrls() {
            if (proxyUrl) {
                var urls = [proxyEndpoint("/remarks").href];
                if (feedUrl) {
                    var fallback = proxyEndpoint("/feed");
                    fallback.searchParams.set("url", new URL(feedUrl, window.location.origin).href);
                    urls.push(fallback.href);
                }
                return urls;
            }
            if (!feedUrl) {
                throw new Error("Missing feed URL");
            }
            var source = new URL(feedUrl, window.location.origin);
            if (source.origin === window.location.origin) {
                return [source.href];
            }
            throw new Error("Missing feed proxy");
        }

        function loadTraffic(forceRefresh) {
            var urls = requestUrls();

            function fetchSource(url) {
                var requestController = new AbortController();
                var requestTimeout = window.setTimeout(function () {
                    requestController.abort();
                }, 12000);

                return fetch(url, {
                    cache: forceRefresh ? "reload" : "default",
                    headers: {
                        Accept: "application/json, application/rss+xml;q=0.9, application/xml;q=0.8"
                    },
                    signal: requestController.signal
                }).then(function (response) {
                    if (!response.ok) {
                        throw new Error("Feed responded with " + response.status);
                    }
                    return Promise.all([
                        response.text(),
                        response.headers.get("Content-Type") || "",
                        response.headers.get("X-BahnNews-Data-State") || ""
                    ]);
                }).then(function (responseParts) {
                    return parseTrafficResponse(responseParts[0], responseParts[1], responseParts[2]);
                }).finally(function () {
                    window.clearTimeout(requestTimeout);
                });
            }

            function attempt(index, previousError) {
                if (index >= urls.length) {
                    return Promise.reject(previousError);
                }

                return fetchSource(urls[index]).catch(function (error) {
                    return attempt(index + 1, error);
                });
            }

            return attempt(0, new Error("Traffic source is unavailable"));
        }

        function pollForFreshData(fetchedAt, attempt) {
            if (!proxyUrl || !fetchedAt || attempt > 5 || !refreshNotice || !refreshMessage) {
                return;
            }
            window.setTimeout(function () {
                var statusUrl = proxyEndpoint("/remarks/status");
                statusUrl.searchParams.set("check", String(Date.now()));
                fetch(statusUrl.href, {cache: "no-store", headers: {Accept: "application/json"}})
                    .then(function (response) {
                        if (!response.ok) {
                            throw new Error("Status unavailable");
                        }
                        return response.json();
                    })
                    .then(function (status) {
                        if (status.fetchedAt && Date.parse(status.fetchedAt) > fetchedAt.getTime()) {
                            refreshMessage.textContent = messages.newData;
                            refreshNotice.hidden = false;
                            return;
                        }
                        pollForFreshData(fetchedAt, attempt + 1);
                    })
                    .catch(function () {
                        pollForFreshData(fetchedAt, attempt + 1);
                    });
            }, attempt === 1 ? 10000 : 15000);
        }

        function applyTraffic(parsed) {
            trainLookupGeneration += 1;
            items = parsed.items;
            updateCounts();
            if (!updateHomepageVisibility()) {
                return;
            }
            updateStateOptions();
            renderBoard();
            updateCheckedAt(
                parsed.source === "hafas" && parsed.fetchedAt ? parsed.fetchedAt : parsed.checkedAt,
                parsed.source === "hafas" ? messages.checked : messages.rssChecked
            );
            updateSource(parsed);
            if (parsed.dataState === "last-good") {
                pollForFreshData(parsed.fetchedAt, 1);
            }
        }

        boardTabs.forEach(function (tab) {
            tab.addEventListener("click", function () {
                activeFilter = tab.dataset.boardFilter;
                renderBoard();
            });
            tab.addEventListener("keydown", function (event) {
                var currentIndex = boardTabs.indexOf(tab);
                var nextIndex = currentIndex;
                if (event.key === "ArrowRight") {
                    nextIndex = (currentIndex + 1) % boardTabs.length;
                } else if (event.key === "ArrowLeft") {
                    nextIndex = (currentIndex - 1 + boardTabs.length) % boardTabs.length;
                } else if (event.key === "Home") {
                    nextIndex = 0;
                } else if (event.key === "End") {
                    nextIndex = boardTabs.length - 1;
                } else {
                    return;
                }
                event.preventDefault();
                boardTabs[nextIndex].click();
                boardTabs[nextIndex].focus();
            });
        });

        if (stateSelect) {
            stateSelect.addEventListener("change", function () {
                activeState = stateSelect.value;
                renderBoard();
            });
        }

        if (boardSearch) {
            boardSearch.addEventListener("input", function () {
                window.clearTimeout(searchTimer);
                searchTimer = window.setTimeout(function () {
                    activeQuery = normalizedText(boardSearch.value)
                        .toLocaleLowerCase(document.documentElement.lang || "de");
                    renderBoard();
                }, 120);
            });
        }

        if (refreshButton) {
            refreshButton.addEventListener("click", function () {
                refreshButton.disabled = true;
                Promise.resolve().then(function () {
                    return loadTraffic(true);
                }).then(function (parsed) {
                    refreshNotice.hidden = true;
                    applyTraffic(parsed);
                }).catch(function () {
                    refreshMessage.textContent = messages.loadError;
                }).finally(function () {
                    refreshButton.disabled = false;
                });
            });
        }

        Promise.resolve().then(loadTraffic).then(applyTraffic).catch(function (error) {
            boardPanel.hidden = false;
            boardSource.hidden = false;
            boardStatus.hidden = false;
            boardStatus.textContent = error.message === "Missing feed proxy" || error.message === "Missing feed URL" ?
                messages.setupError : messages.loadError;
            boardUpdated.textContent = messages.sourceError;
            boardRoot.classList.add("has-error");
        });
    });

    document.querySelectorAll("[data-live-update-article]").forEach(function (liveArticle) {
        var content = liveArticle.querySelector("[data-live-update-content]");
        var statusLabel = liveArticle.querySelector("[data-live-status-label]");
        var statusElement = liveArticle.querySelector("[data-live-status]");
        var updateCount = liveArticle.querySelector("[data-live-update-count]");

        if (!content || !statusLabel || !statusElement || !updateCount) {
            return;
        }

        function normalizedText(value) {
            return String(value || "")
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .toLocaleLowerCase(document.documentElement.lang || "de")
                .replace(/\s+/g, " ")
                .trim();
        }

        var statusDefinitions = [
            {
                key: "active",
                label: liveArticle.dataset.liveStatusActive,
                aliases: ["laufend", "live", "aktiv", "ongoing", "active"]
            },
            {
                key: "monitoring",
                label: liveArticle.dataset.liveStatusMonitoring,
                aliases: ["beobachtung", "entspannung", "monitoring", "under observation"]
            },
            {
                key: "resolved",
                label: liveArticle.dataset.liveStatusResolved,
                aliases: ["beendet", "abgeschlossen", "aufgehoben", "resolved", "closed", "ended"]
            }
        ];
        var internalTags = String(liveArticle.dataset.liveUpdateInternalTags || "")
            .split("||")
            .map(function (tag) {
                return tag.trim();
            })
            .filter(Boolean);
        var statusTag = internalTags.find(function (tag) {
            return /^#?live-status\s+/i.test(tag);
        });
        var requestedStatus = statusTag ?
            normalizedText(statusTag.replace(/^#?live-status\s+/i, "")) :
            "laufend";
        var activeStatus = statusDefinitions.find(function (status) {
            return status.aliases.includes(requestedStatus);
        }) || statusDefinitions[0];

        function applyLiveStatus(status) {
            liveArticle.dataset.liveStatus = status.key;
            statusElement.dataset.liveStatus = status.key;
            statusLabel.textContent = status.label;
        }

        applyLiveStatus(activeStatus);

        var hafasTag = internalTags.find(function (tag) {
            return /^#?hafas\s+/i.test(tag);
        });
        var hafasId = hafasTag ? hafasTag.replace(/^#?hafas\s+/i, "").trim() : "";
        var hafasCard = liveArticle.querySelector("[data-live-hafas-card]");
        var hafasProxyUrl = liveArticle.dataset.liveHafasProxyUrl;

        if (hafasId && hafasCard && hafasProxyUrl) {
            var hafasTitle = hafasCard.querySelector("[data-live-hafas-title]");
            var hafasText = hafasCard.querySelector("[data-live-hafas-text]");
            var hafasType = hafasCard.querySelector("[data-live-hafas-type]");
            var hafasRegions = hafasCard.querySelector("[data-live-hafas-regions]");
            var hafasTime = hafasCard.querySelector("[data-live-hafas-time]");
            var hafasFetched = hafasCard.querySelector("[data-live-hafas-fetched]");
            var hafasDate = new Intl.DateTimeFormat(document.documentElement.lang || "de", {
                dateStyle: "medium",
                timeStyle: "short"
            });

            function loadLinkedHafas() {
                var endpoint = new URL(hafasProxyUrl, window.location.origin);
                endpoint.pathname = endpoint.pathname.replace(/\/remarks\/?$/, "").replace(/\/$/, "") + "/remarks";
                endpoint.search = "";
                endpoint.hash = "";

                return fetch(endpoint.href, {
                    cache: "no-cache",
                    headers: {Accept: "application/json"}
                }).then(function (response) {
                    if (!response.ok) {
                        throw new Error("HAFAS unavailable");
                    }
                    return response.json();
                }).then(function (payload) {
                    var remarks = Array.isArray(payload.remarks) ? payload.remarks : [];
                    var remark = remarks.find(function (item) {
                        return String(item.id) === hafasId;
                    });
                    if (!remark) {
                        return;
                    }

                    var resolved = String(remark.iconType || "").toUpperCase() === "HIM6";
                    var reportStatus = statusDefinitions.find(function (status) {
                        return status.key === (resolved ? "resolved" : "active");
                    });
                    var modified = remark.modified || remark.validFrom;
                    var fetched = payload.fetchedAt;

                    hafasTitle.textContent = String(remark.summary || remark.text || "").trim();
                    hafasText.textContent = String(remark.text || "").trim();
                    hafasText.hidden = !hafasText.textContent || hafasText.textContent === hafasTitle.textContent;
                    hafasType.textContent = resolved ?
                        liveArticle.dataset.liveHafasResolved : liveArticle.dataset.liveHafasActive;
                    hafasRegions.textContent = Array.isArray(remark.regions) ? remark.regions.join(" · ") : "";
                    hafasRegions.hidden = !hafasRegions.textContent;
                    hafasTime.textContent = modified ? hafasDate.format(new Date(modified)) : "";
                    hafasTime.dateTime = modified || "";
                    hafasTime.hidden = !modified;
                    hafasFetched.textContent = fetched ?
                        liveArticle.dataset.liveHafasChecked + " " + hafasDate.format(new Date(fetched)) : "";
                    hafasCard.dataset.liveHafasStatus = resolved ? "resolved" : "active";
                    hafasCard.hidden = false;
                    applyLiveStatus(reportStatus);
                });
            }

            Promise.resolve().then(loadLinkedHafas).catch(function () {});
            window.setInterval(function () {
                loadLinkedHafas().catch(function () {});
            }, 300000);
        }

        var updateCards = Array.from(content.querySelectorAll(":scope > .kg-toggle-card"));
        if (!updateCards.length) {
            updateCount.textContent = "0 " + liveArticle.dataset.liveUpdatePlural;
            return;
        }

        var timeline = document.createElement("div");
        timeline.className = "live-update-timeline";
        timeline.setAttribute("role", "list");
        content.insertBefore(timeline, updateCards[0]);

        updateCards.forEach(function (card, index) {
            var heading = card.querySelector(".kg-toggle-heading-text");
            var toggleButton = card.querySelector(".kg-toggle-card-icon");
            var toggleContent = card.querySelector(".kg-toggle-content");
            var rawHeading = heading ? heading.textContent.replace(/\s+/g, " ").trim() : "";
            var titleParts = rawHeading.match(/^(.+?)\s+[–—]\s+(.+)$/);

            card.classList.toggle("is-latest", index === 0);
            card.setAttribute("role", "listitem");
            if (index === 0) {
                card.setAttribute("data-kg-toggle-state", "open");
            }

            if (heading && titleParts) {
                var updateTime = document.createElement("span");
                var updateTitle = document.createElement("span");

                updateTime.className = "live-update-time";
                updateTime.textContent = titleParts[1];
                updateTitle.className = "live-update-title";
                updateTitle.textContent = titleParts[2];
                heading.replaceChildren(updateTime, updateTitle);
            }

            if (heading && index === 0) {
                var latestLabel = document.createElement("span");
                latestLabel.className = "live-update-latest";
                latestLabel.textContent = liveArticle.dataset.liveLatestLabel;
                heading.prepend(latestLabel);
            }

            if (toggleButton && toggleContent) {
                var contentId = "live-update-content-" + (index + 1);
                var updateToggleAccessibility = function () {
                    var isOpen = card.getAttribute("data-kg-toggle-state") === "open";
                    toggleButton.setAttribute("aria-expanded", String(isOpen));
                    toggleButton.setAttribute("aria-controls", contentId);
                    toggleButton.setAttribute(
                        "aria-label",
                        isOpen ? liveArticle.dataset.liveCollapseLabel : liveArticle.dataset.liveExpandLabel
                    );
                };

                toggleContent.id = contentId;
                updateToggleAccessibility();
                toggleButton.addEventListener("click", function () {
                    window.setTimeout(updateToggleAccessibility, 0);
                });
            }

            timeline.appendChild(card);
        });

        var countLabel = updateCards.length === 1 ?
            liveArticle.dataset.liveUpdateSingular :
            liveArticle.dataset.liveUpdatePlural;
        updateCount.textContent = updateCards.length + " " + countLabel;
    });

    var vehicleTypeDefinitions = [
        {
            key: "powered-vehicle",
            labelDe: "Triebfahrzeug",
            labelEn: "Powered vehicle",
            icon: "powered-vehicle",
            groups: ["powered"],
            aliases: ["triebfahrzeug", "powered vehicle", "traction vehicle"]
        },
        {
            key: "locomotive",
            labelDe: "Lokomotive",
            labelEn: "Locomotive",
            icon: "locomotive",
            groups: ["powered"],
            aliases: [
                "lokomotive", "lok", "ellok", "diesellok", "elektrolokomotive",
                "diesellokomotive", "locomotive", "electric locomotive", "diesel locomotive"
            ]
        },
        {
            key: "trainset",
            labelDe: "Triebzug",
            labelEn: "Trainset",
            icon: "trainset",
            groups: ["powered"],
            aliases: [
                "triebzug", "elektrotriebzug", "dieseltriebzug", "batterietriebzug",
                "wasserstofftriebzug", "trainset", "multiple unit", "electric multiple unit",
                "diesel multiple unit"
            ]
        },
        {
            key: "railcar",
            labelDe: "Triebwagen",
            labelEn: "Railcar",
            icon: "railcar",
            groups: ["powered"],
            aliases: [
                "triebwagen", "elektrotriebwagen", "dieseltriebwagen", "batterietriebwagen",
                "wasserstofftriebwagen", "railcar", "motor coach"
            ]
        },
        {
            key: "coach",
            labelDe: "Wagen",
            labelEn: "Coach or wagon",
            icon: "coach",
            groups: ["coach"],
            aliases: ["wagen", "coach", "wagon"]
        },
        {
            key: "passenger-coach",
            labelDe: "Reisezugwagen",
            labelEn: "Passenger coach",
            icon: "coach",
            groups: ["coach"],
            aliases: ["reisezugwagen", "personenwagen", "passenger coach", "passenger carriage"]
        },
        {
            key: "driving-trailer",
            labelDe: "Steuerwagen",
            labelEn: "Driving trailer",
            icon: "driving-trailer",
            groups: ["coach"],
            aliases: ["steuerwagen", "driving trailer", "cab car"]
        },
        {
            key: "freight-wagon",
            labelDe: "Güterwagen",
            labelEn: "Freight wagon",
            icon: "freight-wagon",
            groups: ["coach"],
            aliases: ["guterwagen", "güterwagen", "freight wagon", "freight car"]
        },
        {
            key: "special",
            labelDe: "Sonderfahrzeug",
            labelEn: "Special vehicle",
            icon: "special",
            groups: ["special"],
            aliases: [
                "sonderfahrzeug", "instandhaltungsfahrzeug", "gleisbaumaschine",
                "bahndienstfahrzeug", "special vehicle", "maintenance vehicle"
            ]
        }
    ];
    var vehiclePropulsionDefinitions = [
        {
            key: "electric",
            labelDe: "Elektro",
            labelEn: "Electric",
            icon: "electric",
            aliases: [
                "elektro", "elektrisch", "electric", "ellok", "elektrolokomotive",
                "elektrotriebzug", "elektrotriebwagen", "electric locomotive",
                "electric multiple unit"
            ]
        },
        {
            key: "diesel",
            labelDe: "Diesel",
            labelEn: "Diesel",
            icon: "diesel",
            aliases: [
                "diesel", "diesellok", "diesellokomotive", "dieseltriebzug",
                "dieseltriebwagen", "diesel locomotive", "diesel multiple unit"
            ]
        },
        {
            key: "battery",
            labelDe: "Batterie",
            labelEn: "Battery",
            icon: "battery",
            aliases: [
                "batterie", "akku", "batterieelektrisch", "battery", "battery electric",
                "batterietriebzug", "batterietriebwagen"
            ]
        },
        {
            key: "hydrogen",
            labelDe: "Wasserstoff",
            labelEn: "Hydrogen",
            icon: "hydrogen",
            aliases: [
                "wasserstoff", "brennstoffzelle", "hydrogen", "fuel cell",
                "wasserstofftriebzug", "wasserstofftriebwagen"
            ]
        },
        {
            key: "hybrid",
            labelDe: "Hybrid",
            labelEn: "Hybrid",
            icon: "hybrid",
            aliases: ["hybrid", "bimodal", "bi-mode", "dual mode", "zweikraft"]
        },
        {
            key: "steam",
            labelDe: "Dampf",
            labelEn: "Steam",
            icon: "steam",
            aliases: ["dampf", "dampflokomotive", "steam", "steam locomotive"]
        },
        {
            key: "unpowered",
            labelDe: "Ohne Eigenantrieb",
            labelEn: "Unpowered",
            icon: "unpowered",
            aliases: ["ohne eigenantrieb", "antriebslos", "unpowered", "no propulsion"]
        }
    ];
    var vehicleIconMarkup = {
        "powered-vehicle": "<path d=\"M5 17V9.5A3.5 3.5 0 0 1 8.5 6h7A3.5 3.5 0 0 1 19 9.5V17\"></path><path d=\"M7 17h10l2 3H5l2-3Z\"></path><path d=\"M8 10h8M8 14h.01M16 14h.01\"></path>",
        locomotive: "<path d=\"M4 17h16M6 17V9h9a3 3 0 0 1 3 3v5\"></path><path d=\"M9 9V6h5l2 3M8 13h3M17 13h1\"></path><circle cx=\"9\" cy=\"18\" r=\"1.5\"></circle><circle cx=\"17\" cy=\"18\" r=\"1.5\"></circle>",
        trainset: "<path d=\"M6 18V8.5A3.5 3.5 0 0 1 9.5 5h5A3.5 3.5 0 0 1 18 8.5V18\"></path><path d=\"M8 9h8M8 13h.01M16 13h.01M5 18h14M8 21l2-3m6 3-2-3\"></path>",
        railcar: "<rect x=\"4\" y=\"6\" width=\"16\" height=\"12\" rx=\"3\"></rect><path d=\"M7 10h4m2 0h4M4 14h16M8 21l2-3m6 3-2-3\"></path>",
        coach: "<path d=\"M4 7h16v10H4zM7 10h2m2 0h2m2 0h2M6 20l2-3m10 3-2-3\"></path>",
        "driving-trailer": "<path d=\"M4 17V8h11a5 5 0 0 1 5 5v4H4Z\"></path><path d=\"M7 11h4m3 0h3M4 14h16M7 20l2-3m9 3-2-3\"></path>",
        "freight-wagon": "<path d=\"M4 8h16l-2 9H6L4 8Z\"></path><path d=\"M7 8V5m10 3V5M8 20l2-3m6 3-2-3\"></path>",
        special: "<path d=\"M4 17h16M6 17V9h7l3 3h2v5\"></path><path d=\"m9 12 5-5m-2-2 4 4M8 20l2-3m7 3-2-3\"></path>",
        electric: "<path d=\"m13 2-7 12h6l-1 8 7-12h-6l1-8Z\"></path>",
        diesel: "<path d=\"M12 3s5 6 5 11a5 5 0 0 1-10 0c0-5 5-11 5-11Z\"></path><path d=\"M9.5 15.5c.7 1 1.5 1.5 2.5 1.5\"></path>",
        battery: "<rect x=\"4\" y=\"7\" width=\"15\" height=\"10\" rx=\"2\"></rect><path d=\"M19 10h2v4h-2M8 12h7M11.5 8.5v7\"></path>",
        hydrogen: "<circle cx=\"8\" cy=\"12\" r=\"3\"></circle><circle cx=\"16\" cy=\"8\" r=\"2.5\"></circle><circle cx=\"16\" cy=\"16\" r=\"2.5\"></circle><path d=\"m10.5 10.5 3-1.5m-3 4.5 3 1.5\"></path>",
        hybrid: "<path d=\"m11 3-5 9h5l-1 9 5-10h-5l1-8Z\"></path><path d=\"M17 5s3 3.5 3 6a3 3 0 0 1-4.5 2.6\"></path>",
        steam: "<path d=\"M6 17h12M8 17v-5h8v5M10 12V8h4v4\"></path><path d=\"M8 6c-1-1-.3-3 1.2-3M12 6c-1-1-.3-3 1.2-3M16 6c-1-1-.3-3 1.2-3\"></path>",
        unpowered: "<circle cx=\"12\" cy=\"12\" r=\"8\"></circle><path d=\"m7 17 10-10\"></path>"
    };

    function normalizedVehicleValue(value) {
        return String(value || "")
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .toLocaleLowerCase(document.documentElement.lang || "de")
            .replace(/\s+/g, " ")
            .trim();
    }

    function resolvedVehicleDefinition(rawValue, definitions) {
        var normalizedValue = normalizedVehicleValue(rawValue);
        return definitions.find(function (definition) {
            return definition.aliases.some(function (alias) {
                return normalizedVehicleValue(alias) === normalizedValue;
            });
        }) || null;
    }

    function vehicleTagValue(tags, prefixes) {
        var matchingTag = tags.find(function (tag) {
            return prefixes.some(function (prefix) {
                return normalizedVehicleValue(tag).startsWith(prefix + " ");
            });
        });
        if (!matchingTag) {
            return "";
        }
        var normalizedTag = String(matchingTag).replace(/^#/, "");
        var prefix = prefixes.find(function (candidate) {
            return normalizedVehicleValue(normalizedTag).startsWith(candidate + " ");
        });
        return prefix ? normalizedTag.slice(prefix.length).trim() : "";
    }

    function inferredVehicleDefinition(tags, definitions) {
        for (var index = 0; index < tags.length; index += 1) {
            var definition = resolvedVehicleDefinition(tags[index].replace(/^#/, ""), definitions);
            if (definition) {
                return definition;
            }
        }
        return null;
    }

    function inferredVehicleDefinitionFromText(text, definitions) {
        var normalizedText = " " + normalizedVehicleValue(text)
            .replace(/[^a-z0-9ß'-]+/g, " ")
            .replace(/\s+/g, " ") + " ";
        var bestMatch = null;
        var bestLength = 0;

        definitions.forEach(function (definition) {
            definition.aliases.forEach(function (alias) {
                var normalizedAlias = normalizedVehicleValue(alias);
                if (
                    normalizedAlias.length > bestLength &&
                    normalizedText.includes(" " + normalizedAlias + " ")
                ) {
                    bestMatch = definition;
                    bestLength = normalizedAlias.length;
                }
            });
        });
        return bestMatch;
    }

    function vehicleMetadata(rawInternalTags, rawPublicTags, fallbackText) {
        var internalTags = String(rawInternalTags || "").split("||").map(function (tag) {
            return tag.trim();
        }).filter(Boolean);
        var publicTags = String(rawPublicTags || "").split("||").map(function (tag) {
            return tag.trim();
        }).filter(Boolean);
        var allTags = internalTags.concat(publicTags);
        var series = internalTags.find(function (tag) {
            return /^#?baureihe\s+/i.test(tag);
        });
        var nickname = internalTags.find(function (tag) {
            return /^#?spitzname\s+/i.test(tag);
        });
        var typeValue = vehicleTagValue(internalTags, ["fahrzeugart", "fahrzeugtyp", "vehicle type"]);
        var propulsionValue = vehicleTagValue(internalTags, ["antrieb", "energiequelle", "propulsion", "power source"]);
        var type = resolvedVehicleDefinition(typeValue, vehicleTypeDefinitions) ||
            inferredVehicleDefinition(allTags, vehicleTypeDefinitions) ||
            inferredVehicleDefinitionFromText(fallbackText, vehicleTypeDefinitions);
        var propulsion = resolvedVehicleDefinition(propulsionValue, vehiclePropulsionDefinitions) ||
            inferredVehicleDefinition(allTags, vehiclePropulsionDefinitions) ||
            inferredVehicleDefinitionFromText(fallbackText, vehiclePropulsionDefinitions);

        if (type && type.groups.includes("coach")) {
            propulsion = resolvedVehicleDefinition("Ohne Eigenantrieb", vehiclePropulsionDefinitions);
        }

        return {
            series: series ? series.replace(/^#?/, "") : "",
            nickname: nickname ? nickname.replace(/^#?spitzname\s+/i, "") : "",
            type: type,
            propulsion: propulsion
        };
    }

    function createVehicleIcon(iconName) {
        var namespace = "http://www.w3.org/2000/svg";
        var icon = document.createElementNS(namespace, "svg");
        icon.setAttribute("viewBox", "0 0 24 24");
        icon.setAttribute("aria-hidden", "true");
        icon.setAttribute("focusable", "false");
        icon.innerHTML = vehicleIconMarkup[iconName] || vehicleIconMarkup["powered-vehicle"];
        return icon;
    }

    function createVehicleBadge(definition, kind, isGerman) {
        var badge = document.createElement("span");
        var label = document.createElement("span");

        badge.className = "vehicle-classification-badge";
        badge.dataset.vehicleKind = kind;
        badge.dataset.vehicleValue = definition.key;
        label.textContent = isGerman ? definition.labelDe : definition.labelEn;
        badge.append(createVehicleIcon(definition.icon), label);
        return badge;
    }

    function renderVehicleClassification(container, metadata) {
        if (!container) {
            return;
        }
        var isGerman = document.documentElement.lang.startsWith("de");
        container.replaceChildren();
        if (metadata.type) {
            container.appendChild(createVehicleBadge(metadata.type, "type", isGerman));
        }
        if (metadata.propulsion) {
            container.appendChild(createVehicleBadge(metadata.propulsion, "propulsion", isGerman));
        }
        container.hidden = !container.children.length;
    }

    document.querySelectorAll("[data-vehicle-article]").forEach(function (vehicleArticle) {
        var dataSource = vehicleArticle.querySelector("script[data-vehicle-specs]");
        var specList = vehicleArticle.querySelector("[data-vehicle-spec-list]");
        var status = vehicleArticle.querySelector("[data-vehicle-datasheet-status]");
        var highlights = vehicleArticle.querySelector("[data-vehicle-highlights]");
        var identity = vehicleArticle.querySelector("[data-vehicle-identity]");
        var classification = vehicleArticle.querySelector("[data-vehicle-classification]");
        var lifecycle = vehicleArticle.querySelector("[data-vehicle-lifecycle]");
        var lifecycleLabel = vehicleArticle.querySelector("[data-vehicle-lifecycle-label]");
        var lifecycleTrack = vehicleArticle.querySelector("[data-vehicle-lifecycle-track]");

        var articleMetadata = vehicleMetadata(
            vehicleArticle.dataset.vehicleInternalTags,
            vehicleArticle.dataset.vehiclePublicTags,
            [
                vehicleArticle.querySelector("h1")?.textContent,
                vehicleArticle.querySelector(".article-deck")?.textContent
            ].filter(Boolean).join(" ")
        );
        if (identity && (articleMetadata.series || articleMetadata.nickname)) {
            identity.textContent = [
                articleMetadata.series,
                articleMetadata.nickname ? "„" + articleMetadata.nickname + "“" : ""
            ].filter(Boolean).join(" · ");
            identity.hidden = false;
        }
        renderVehicleClassification(classification, articleMetadata);

        if (!dataSource || !specList || !status || !highlights) {
            return;
        }

        function normalizedKey(value) {
            return String(value || "")
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .toLocaleLowerCase(document.documentElement.lang || "de")
                .trim();
        }

        function displayValue(value) {
            if (Array.isArray(value)) {
                return value.map(String).join(", ");
            }
            if (typeof value === "string" || typeof value === "number") {
                return String(value).trim();
            }
            return "";
        }

        function createDefinition(label, value) {
            var group = document.createElement("div");
            var term = document.createElement("dt");
            var description = document.createElement("dd");

            term.textContent = label;
            description.textContent = value;
            group.append(term, description);
            return group;
        }

        try {
            var vehicleData = JSON.parse(dataSource.textContent);
            var entries = Object.entries(vehicleData).map(function (entry) {
                return [String(entry[0]).trim(), displayValue(entry[1])];
            }).filter(function (entry) {
                return entry[0] && entry[1];
            });

            if (!entries.length) {
                return;
            }

            specList.replaceChildren();
            entries.forEach(function (entry) {
                specList.appendChild(createDefinition(entry[0], entry[1]));
            });
            specList.hidden = false;
            status.hidden = true;

            var isGerman = document.documentElement.lang.startsWith("de");
            var typeEntry = entries.find(function (entry) {
                return ["fahrzeugart", "fahrzeugtyp", "vehicle type"].includes(normalizedKey(entry[0]));
            });
            var propulsionEntry = entries.find(function (entry) {
                return ["antrieb", "energiequelle", "propulsion", "power source"].includes(normalizedKey(entry[0]));
            });
            var powerSystemEntry = entries.find(function (entry) {
                return ["stromsystem", "power system", "electrification system"].includes(normalizedKey(entry[0]));
            });

            if (!articleMetadata.type && typeEntry) {
                articleMetadata.type = resolvedVehicleDefinition(typeEntry[1], vehicleTypeDefinitions);
            }
            if (!articleMetadata.propulsion && propulsionEntry) {
                articleMetadata.propulsion = resolvedVehicleDefinition(propulsionEntry[1], vehiclePropulsionDefinitions);
            }
            if (!articleMetadata.propulsion && typeEntry) {
                articleMetadata.propulsion = resolvedVehicleDefinition(typeEntry[1], vehiclePropulsionDefinitions);
            }
            if (!articleMetadata.propulsion && powerSystemEntry) {
                articleMetadata.propulsion = resolvedVehicleDefinition("Elektro", vehiclePropulsionDefinitions);
            }
            if (articleMetadata.type && articleMetadata.type.groups.includes("coach")) {
                articleMetadata.propulsion = resolvedVehicleDefinition(
                    "Ohne Eigenantrieb",
                    vehiclePropulsionDefinitions
                );
            }
            renderVehicleClassification(classification, articleMetadata);

            var lifecycleStatuses = [
                {
                    key: "planned",
                    label: isGerman ? "Geplant" : "Planned",
                    aliases: ["geplant", "in planung", "planned", "planning"]
                },
                {
                    key: "ordered",
                    label: isGerman ? "Bestellt" : "Ordered",
                    aliases: ["bestellt", "beauftragt", "ordered", "on order"]
                },
                {
                    key: "testing",
                    label: isGerman ? "In Erprobung" : "In testing",
                    aliases: ["in erprobung", "erprobung", "in tests", "testbetrieb", "in testing", "testing", "test service"]
                },
                {
                    key: "approval",
                    label: isGerman ? "In Zulassung" : "In approval",
                    aliases: ["in zulassung", "zulassung", "in approval", "approval", "certification"]
                },
                {
                    key: "active",
                    label: isGerman ? "Im Einsatz" : "In service",
                    aliases: ["im einsatz", "in betrieb", "aktiv", "in service", "active", "operational"]
                },
                {
                    key: "phasing-out",
                    label: isGerman ? "Teilweise ausgemustert" : "Being phased out",
                    aliases: ["teilweise ausgemustert", "in ausmusterung", "ausmusterung", "auslaufend", "being phased out", "phasing out", "partially retired"]
                },
                {
                    key: "retired",
                    label: isGerman ? "Ausgemustert" : "Retired",
                    aliases: ["ausgemustert", "außer dienst", "ausser dienst", "retired", "withdrawn", "out of service"]
                }
            ];
            var statusEntry = entries.find(function (entry) {
                return ["status", "fahrzeugstatus", "vehicle status"].includes(normalizedKey(entry[0]));
            });

            if (statusEntry && lifecycle && lifecycleLabel && lifecycleTrack) {
                var normalizedStatus = normalizedKey(statusEntry[1]);
                var lifecycleIndex = lifecycleStatuses.findIndex(function (lifecycleStatus) {
                    return lifecycleStatus.aliases.includes(normalizedStatus);
                });

                if (lifecycleIndex !== -1) {
                    var activeLifecycleStatus = lifecycleStatuses[lifecycleIndex];
                    lifecycle.dataset.lifecycleStatus = activeLifecycleStatus.key;
                    lifecycle.style.setProperty(
                        "--vehicle-lifecycle-progress",
                        (lifecycleIndex / (lifecycleStatuses.length - 1) * 100) + "%"
                    );
                    lifecycleLabel.textContent = activeLifecycleStatus.label;
                    lifecycleTrack.replaceChildren();

                    lifecycleStatuses.forEach(function (lifecycleStatus, index) {
                        var station = document.createElement("span");
                        station.title = lifecycleStatus.label;
                        station.classList.toggle("is-complete", index <= lifecycleIndex);
                        station.classList.toggle("is-current", index === lifecycleIndex);
                        lifecycleTrack.appendChild(station);
                    });

                    lifecycle.setAttribute(
                        "aria-label",
                        (isGerman ? "Fahrzeugstatus: " : "Vehicle status: ") + activeLifecycleStatus.label
                    );
                    lifecycle.hidden = false;
                }
            }

            var highlightKeys = [
                {
                    aliases: ["hochstgeschwindigkeit", "vmax", "top speed", "maximum speed"],
                    label: "V/Max"
                },
                {
                    aliases: ["leistung", "power", "power output"],
                    label: isGerman ? "Leistung" : "Power"
                },
                {
                    aliases: ["sitzplatze", "sitze", "seats", "seating capacity"],
                    label: isGerman ? "Sitzplätze" : "Seats"
                }
            ];

            highlights.replaceChildren();
            highlightKeys.forEach(function (highlight) {
                var match = entries.find(function (entry) {
                    return highlight.aliases.includes(normalizedKey(entry[0]));
                });
                if (match) {
                    highlights.appendChild(createDefinition(highlight.label, match[1]));
                }
            });
            highlights.hidden = !highlights.children.length;
        } catch (error) {
            console.warn("BahnNews vehicle data could not be parsed.", error);
        }
    });

    document.querySelectorAll("[data-vehicle-directory]").forEach(function (directory) {
        var searchForm = directory.querySelector("[data-vehicle-search-form]");
        var searchInput = directory.querySelector("[data-vehicle-search]");
        var typeFilter = directory.querySelector("[data-vehicle-type-filter]");
        var propulsionFilter = directory.querySelector("[data-vehicle-propulsion-filter]");
        var filterReset = directory.querySelector("[data-vehicle-filter-reset]");
        var cards = Array.from(directory.querySelectorAll("[data-vehicle-card]"));
        var resultCount = directory.querySelector("[data-vehicle-result-count]");
        var resultLabel = directory.querySelector("[data-vehicle-result-label]");
        var noResults = directory.querySelector("[data-vehicle-no-results]");
        var isGerman = document.documentElement.lang.startsWith("de");

        if (!searchForm || !searchInput || !resultCount || !resultLabel || !cards.length) {
            return;
        }

        function searchableText(value) {
            return String(value || "")
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .toLocaleLowerCase(document.documentElement.lang || "de")
                .replace(/\s+/g, " ")
                .trim();
        }

        var searchableCards = cards.map(function (card) {
            var metadata = vehicleMetadata(
                card.dataset.vehicleInternalTags,
                card.dataset.vehiclePublicTags,
                card.dataset.vehicleArticleTitle + " " + card.textContent
            );
            var title = card.querySelector("[data-vehicle-card-title]");
            var nickname = card.querySelector("[data-vehicle-card-nickname]");
            var classification = card.querySelector("[data-vehicle-classification]");

            if (metadata.series && title) {
                title.textContent = metadata.series;
            }
            if (metadata.nickname && nickname) {
                nickname.textContent = "„" + metadata.nickname + "“";
                nickname.hidden = false;
            }
            renderVehicleClassification(classification, metadata);

            return {
                element: card,
                metadata: metadata,
                text: searchableText(card.textContent + " " + card.dataset.vehicleArticleTitle)
            };
        });

        function matchesType(metadata, requestedType) {
            if (!requestedType) {
                return true;
            }
            if (!metadata.type) {
                return false;
            }
            if (requestedType === "powered" || requestedType === "coach") {
                return (metadata.type.groups || []).includes(requestedType);
            }
            return metadata.type.key === requestedType;
        }

        function updateDirectory() {
            var query = searchableText(searchInput.value);
            var requestedType = typeFilter ? typeFilter.value : "";
            var requestedPropulsion = propulsionFilter ? propulsionFilter.value : "";
            var visibleCount = 0;

            searchableCards.forEach(function (card) {
                var matchesQuery = !query || card.text.includes(query);
                var matchesRequestedType = matchesType(card.metadata, requestedType);
                var matchesPropulsion = !requestedPropulsion ||
                    (card.metadata.propulsion && card.metadata.propulsion.key === requestedPropulsion);
                var visible = matchesQuery && matchesRequestedType && matchesPropulsion;
                card.element.hidden = !visible;
                if (visible) {
                    visibleCount += 1;
                }
            });

            resultCount.textContent = String(visibleCount);
            resultLabel.textContent = isGerman ?
                (visibleCount === 1 ? "Fahrzeug gefunden" : "Fahrzeuge gefunden") :
                (visibleCount === 1 ? "vehicle found" : "vehicles found");
            if (noResults) {
                noResults.hidden = visibleCount !== 0;
            }
            if (filterReset) {
                filterReset.hidden = !query && !requestedType && !requestedPropulsion;
            }
        }

        searchForm.addEventListener("submit", function (event) {
            event.preventDefault();
        });
        searchInput.addEventListener("input", updateDirectory);
        if (typeFilter) {
            typeFilter.addEventListener("change", updateDirectory);
        }
        if (propulsionFilter) {
            propulsionFilter.addEventListener("change", updateDirectory);
        }
        if (filterReset) {
            filterReset.addEventListener("click", function () {
                searchInput.value = "";
                if (typeFilter) {
                    typeFilter.value = "";
                }
                if (propulsionFilter) {
                    propulsionFilter.value = "";
                }
                updateDirectory();
                searchInput.focus();
            });
        }
        updateDirectory();
    });

    document.querySelectorAll("[data-article-outline]").forEach(function (article) {
        var content = article.querySelector("[data-article-content]");
        var outline = article.querySelector("[data-article-outline-nav]");
        var outlineList = article.querySelector("[data-article-outline-list]");
        var story = article.querySelector(".cinema-story");

        if (!content || !outline || !outlineList || !story) {
            return;
        }

        var headings = Array.from(content.querySelectorAll("h2, h3"));
        if (!headings.length) {
            story.classList.add("is-outline-empty");
            return;
        }

        var usedIds = new Set(Array.from(document.querySelectorAll("[id]")).map(function (element) {
            return element.id;
        }));

        function headingId(heading, index) {
            if (heading.id) {
                return heading.id;
            }

            var base = heading.textContent
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .toLowerCase()
                .replace(/[^a-z0-9]+/g, "-")
                .replace(/(^-|-$)/g, "") || "abschnitt-" + (index + 1);
            var candidate = base;
            var suffix = 2;
            while (usedIds.has(candidate)) {
                candidate = base + "-" + suffix;
                suffix += 1;
            }
            heading.id = candidate;
            usedIds.add(candidate);
            return candidate;
        }

        var outlineItems = headings.map(function (heading, index) {
            var item = document.createElement("li");
            var link = document.createElement("a");
            link.href = "#" + headingId(heading, index);
            link.textContent = heading.textContent.trim();
            if (heading.tagName === "H3") {
                item.classList.add("is-subsection");
            }
            item.appendChild(link);
            outlineList.appendChild(item);
            return item;
        });

        outline.hidden = false;
        outlineItems[0].classList.add("is-current");
        outlineItems[0].querySelector("a").setAttribute("aria-current", "location");

        function markCurrent(index) {
            outlineItems.forEach(function (item, itemIndex) {
                var current = itemIndex === index;
                item.classList.toggle("is-current", current);
                if (current) {
                    item.querySelector("a").setAttribute("aria-current", "location");
                } else {
                    item.querySelector("a").removeAttribute("aria-current");
                }
            });
        }

        if ("IntersectionObserver" in window) {
            var headingObserver = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        markCurrent(headings.indexOf(entry.target));
                    }
                });
            }, {rootMargin: "-18% 0px -68% 0px"});
            headings.forEach(function (heading) {
                headingObserver.observe(heading);
            });
        }
    });

    document.querySelectorAll("[data-article-chapters]").forEach(function (content) {
        content.querySelectorAll("h2").forEach(function (heading, index) {
            if (heading.querySelector(".article-chapter-number")) {
                return;
            }
            var number = document.createElement("span");
            number.className = "article-chapter-number";
            number.setAttribute("aria-hidden", "true");
            number.textContent = String(index + 1).padStart(2, "0");
            heading.prepend(number);
        });
    });

    document.querySelectorAll("[data-featured-carousel]").forEach(function (carousel) {
        var slides = Array.from(carousel.querySelectorAll("[data-featured-slide]"));
        var indicators = Array.from(carousel.querySelectorAll("[data-carousel-go]"));
        var previousButton = carousel.querySelector("[data-carousel-prev]");
        var nextButton = carousel.querySelector("[data-carousel-next]");
        var status = carousel.querySelector("[data-carousel-status]");
        var current = 0;
        var timer;
        var pointerStart = null;

        if (slides.length < 2) {
            return;
        }

        function showSlide(index, announce) {
            current = (index + slides.length) % slides.length;
            slides.forEach(function (slide, slideIndex) {
                var active = slideIndex === current;
                slide.classList.toggle("is-active", active);
                slide.setAttribute("aria-hidden", String(!active));
            });
            indicators.forEach(function (indicator, indicatorIndex) {
                var active = indicatorIndex === current;
                indicator.classList.toggle("is-active", active);
                indicator.setAttribute("aria-pressed", String(active));
            });
            if (status && announce) {
                status.textContent = "Topmeldung " + (current + 1) + " von " + slides.length;
            }
        }

        function stopRotation() {
            window.clearInterval(timer);
        }

        function startRotation() {
            stopRotation();
            if (!motionQuery.matches && !document.hidden) {
                timer = window.setInterval(function () {
                    showSlide(current + 1, false);
                }, 7000);
            }
        }

        function restartRotationUnlessFocused() {
            if (carousel.contains(document.activeElement)) {
                stopRotation();
            } else {
                startRotation();
            }
        }

        previousButton.addEventListener("click", function () {
            showSlide(current - 1, true);
            restartRotationUnlessFocused();
        });

        nextButton.addEventListener("click", function () {
            showSlide(current + 1, true);
            restartRotationUnlessFocused();
        });

        indicators.forEach(function (indicator) {
            indicator.addEventListener("click", function () {
                showSlide(Number(indicator.dataset.carouselGo), true);
                restartRotationUnlessFocused();
            });
        });

        carousel.addEventListener("mouseenter", stopRotation);
        carousel.addEventListener("mouseleave", restartRotationUnlessFocused);
        carousel.addEventListener("focusin", stopRotation);
        carousel.addEventListener("focusout", function (event) {
            if (!carousel.contains(event.relatedTarget)) {
                startRotation();
            }
        });
        carousel.addEventListener("keydown", function (event) {
            if (event.key === "ArrowLeft") {
                showSlide(current - 1, true);
                restartRotationUnlessFocused();
            }
            if (event.key === "ArrowRight") {
                showSlide(current + 1, true);
                restartRotationUnlessFocused();
            }
        });
        carousel.addEventListener("pointerdown", function (event) {
            pointerStart = event.clientX;
        });
        carousel.addEventListener("pointerup", function (event) {
            if (pointerStart === null) {
                return;
            }
            var distance = event.clientX - pointerStart;
            pointerStart = null;
            if (Math.abs(distance) > 45) {
                showSlide(current + (distance < 0 ? 1 : -1), true);
                restartRotationUnlessFocused();
            }
        });
        document.addEventListener("visibilitychange", startRotation);
        motionQuery.addEventListener("change", startRotation);
        startRotation();
    });

    var revealItems = document.querySelectorAll("[data-reveal]");
    if ("IntersectionObserver" in window && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    entry.target.classList.add("is-visible");
                    observer.unobserve(entry.target);
                }
            });
        }, {rootMargin: "0px 0px -7% 0px"});
        revealItems.forEach(function (item) {
            observer.observe(item);
        });
    } else {
        revealItems.forEach(function (item) {
            item.classList.add("is-visible");
        });
    }
}());
